






























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { FORMAT_CURRENCY } from '@/utils/formatPrice';
import Loading from '@/components/Loading.vue';
import { IInvoice } from "@/interfaces/IInvoice";
import { GetterNames } from "@/constants/GetterNames";
import { ActionNames } from "@/constants/ActionNames";
import * as moment from 'moment';

@Component({
  components: {
    Loading,
  },
})
export default class InvoiceList extends Vue {
  public date = moment;

  public loading: boolean = true;

  public orders: IInvoice[] = [];

  public currentPageNumber: number = 1;

  public error: {
    type: string,
    message: string,
    show: boolean,
  } = {
    show: false,
    type: '',
    message: '',
  };

  public formatCurrency = (price: number): string => FORMAT_CURRENCY(price);

  get allOrders(): IInvoice[] {
    return this.$store.getters[GetterNames.INVOICES];
  }

  public async mounted() {
    const success = await this.$store.dispatch(ActionNames.INVOICES);

    if (!success) {
      this.error = {
        show: true,
        type: 'warning',
        message: 'Er ging iets mis tijdens het ophalen van je transacties',
      };

      return;
    }

    this.paginate();
    this.loading = false;
  }

  public paginate() {
    const orders = this.allOrders;
    let pageNumber = this.currentPageNumber;

    this.orders = orders.slice(--pageNumber * 10, (pageNumber + 1) * 10);
  }

  @Watch('currentPageNumber', { immediate: true, deep: true })
  public onPaginate() {
    this.paginate();
  }

  public async getInvoice(invoiceId: number) {
    this.loading = true;

    const success = await this.$store.dispatch(ActionNames.CREATE_INVOICE, invoiceId);

    if (!success) {
      this.error = {
        show: true,
        type: 'warning',
        message: 'Er ging iets mis tijdens het ophalen van de factuur',
      };

      this.loading = false;

      return;
    }

    this.error = {
      show: true,
      type: 'success',
      message: 'Uw factuur is aangemaakt en gedownload',
    };

    this.loading = false;
  }
}
